<template>
  <div>
    <b-form>
      <div class="row mb-1 pb-3 border-bottom g-0" style="--bs-border-color: black">
        <div class="col-md-12 d-flex align-items-center">
          <span class="fw-bold">Kemajuan Perizinan Yang Diperoleh</span>
          <a class="btn btn-warning ms-2 text-white" @click="$bvModal.show('modal-panduan')">
            <i class="fa fa-question-circle" />
            Panduan
          </a>
        </div>
      </div>
      <div class="row mb-3 py-3 border-bottom g-0" style="--bs-border-color: black">
        <div class="col-md-6 d-flex align-items-center">
          <span class="fw-bold">Dokumen KKPRL</span>
        </div>
        <div class="col-md-6 ps-4">
          <div class="row">
            <small>Format file: PDF, Ukuran maksimal: 5MB <span class="text-danger">*</span></small>
            <div class="col-6">
              <b-form-file
                id="file_perizinan_kkprl"
                v-model="file_perizinan_kkprl"
                plain
                class="form-control"
                name="Izin KKPRL Terbit"
                accept=".pdf"
                @change="checkFileSize($event, 'file_perizinan_kkprl')"
                :disabled="is_selesai"
              ></b-form-file>
            </div>
            <div class="col-6 d-flex">
              <a
                v-if="id_file_perizinan_kkprl?.startsWith('http')"
                :class="['btn btn-success', { disabled: !id_file_perizinan_kkprl }]"
                :href="id_file_perizinan_kkprl"
                target="_blank"
              >
                <i class="fa fa-download" />
                Unduh
              </a>
              <a
                v-else
                :class="['btn btn-success', { disabled: !id_file_perizinan_kkprl || id_file_perizinan_kkprl == '0' }]"
                @click="unduhFile(id_file_perizinan_kkprl)"
              >
                <i class="fa fa-download" />
                Unduh
              </a>
            </div>
          </div>
          <div class="text-danger" v-if="errors.has('Izin KKPRL Terbit')">
            {{ errors.first('Izin KKPRL Terbit') }}
          </div>
          <span class="text-danger" v-if="errors.has('file_perizinan_kkprl', 'custom')">
            {{ errors.first('file_perizinan_kkprl', 'custom') }}
          </span>
        </div>
      </div>
      <span>Kemajuan dalam memperoleh:</span>

      <div class="row mb-2 mt-3">
        <div :class="['col-md-6', { 'pe-none': is_selesai }]">
          <div class="row gx-3">
            <div class="col-12">
              <label class="fw-bold"
                >a. persetujuan lingkungan
                <span class="text-danger">*</span>
              </label>
              <div class="w-50 pe-2">
                <v-select
                  v-model="form.persetujuan_lingkungan"
                  id="a_persetujuan_lingkungan"
                  :reduce="(data) => data.value"
                  label="text"
                  :options="optionPersetujuanLingkungan"
                  name="Persetujuan Lingkungan"
                  v-validate="'required'"
                  :class="{
                    input: true,
                    'is-danger': errors.has('Persetujuan Lingkungan'),
                  }"
                />
              </div>
              <span class="text-danger" v-if="errors.has('Persetujuan Lingkungan')">
                {{ errors.first('Persetujuan Lingkungan') }}
              </span>
            </div>
          </div>
        </div>
      </div>
      <div v-if="form.persetujuan_lingkungan === 'Sudah'" class="row mb-3">
        <div :class="['col-md-7', { 'pe-none': is_selesai }]">
          <div class="row gx-3">
            <div class="row">
              <div class="col-6 mt-3 g-3">
                <label>Nomor Perizinan <span class="text-danger">*</span></label>
                <b-form-input
                  v-model="form.a_nomor_perizinan"
                  id="a_nomor_perizinan"
                  v-validate="'required'"
                  name="Nomor Perizinan"
                  :class="{
                    input: true,
                    'is-danger': errors.has('Nomor Perizinan'),
                  }"
                ></b-form-input>
                <span class="text-danger" v-if="errors.has('Nomor Perizinan')">
                  {{ errors.first('Nomor Perizinan') }}
                </span>
              </div>
              <div class="col-6 mt-3 g-3">
                <label>Tanggal Terbit <span class="text-danger">*</span></label>
                <DatePicker
                  id="a_tgl_terbit"
                  lang="en"
                  :placeholder="a_tgl_terbit"
                  input-class="form-control"
                  @change="
                    (val) => {
                      this.a_tgl_terbit = val.toLocaleDateString('en-GB')
                      this.form.a_tgl_terbit = formatDate(val, 'YYYY-MM-DD')
                      this.errors.remove('Tanggal Terbit')
                    }
                  "
                  class="w-100"
                >
                  <i class="fa fa-calendar-o" slot="calendar-icon" />
                </DatePicker>
                <span class="text-danger" v-if="errors.has('Tanggal Terbit')">
                  {{ errors.first('Tanggal Terbit') }}
                </span>
              </div>
              <div class="col-6 mt-3 g-3">
                <label>Instansi Penerbit <span class="text-danger">*</span></label>
                <b-form-input
                  v-model="form.a_instansi_penerbit"
                  id="a_instansi_penerbit"
                  v-validate="'required'"
                  name="Instansi Penerbit"
                  :class="{
                    input: true,
                    'is-danger': errors.has('Instansi Penerbit'),
                  }"
                ></b-form-input>
                <span class="text-danger" v-if="errors.has('Instansi Penerbit')">
                  {{ errors.first('Instansi Penerbit') }}
                </span>
              </div>
              <div class="col-6 mt-3 g-3">
                <label>Masa Berlaku <span class="text-danger">*</span></label>
                <div class="input-units">
                  <b-form-input
                    v-model="form.a_masa_berlaku"
                    id="a_masa_berlaku"
                    v-mask="integerMask(form.a_masa_berlaku)"
                    v-validate="'required'"
                    name="Masa Berlaku"
                    :class="{
                      input: true,
                      'is-danger': errors.has('Masa Berlaku'),
                    }"
                  ></b-form-input>
                  <div class="text-units">
                    <span>{{ form.a_masa_berlaku }}</span>
                    <span> tahun</span>
                  </div>
                </div>
                <span class="text-danger" v-if="errors.has('Masa Berlaku')">
                  {{ errors.first('Masa Berlaku') }}
                </span>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-5">
          <label> Upload dokumentasi/bukti dukung </label>
          <div class="row">
            <div>
              <small>Format file: PDF, Ukuran maksimal: 5MB</small>
            </div>
            <div class="col-8">
              <b-form-file
                v-model="form.a_dokumentasi"
                id="a_dokumentasi"
                plain
                class="form-control"
                name="a. Dokumentasi"
                accept=".pdf"
                @change="checkFileSize($event, 'dokumentasi-a')"
                :disabled="is_selesai"
              ></b-form-file>
            </div>
            <div v-if="a_id_file_dokumentasi" class="col-4 d-flex">
              <a
                :class="{
                  'btn btn-success': true,
                  disabled: a_id_file_dokumentasi === null,
                }"
                @click="unduhFile(a_id_file_dokumentasi)"
              >
                <i class="fa fa-download" />
                Unduh
              </a>
            </div>
          </div>
          <span class="text-danger" v-if="errors.has('Dokumentasi')">
            {{ errors.first('Dokumentasi') }}
          </span>
          <span class="text-danger" v-if="errors.has('dokumentasi-a', 'custom')">
            {{ errors.first('dokumentasi-a', 'custom') }}
          </span>
        </div>
      </div>
      <div class="row mb-1 pb-3 border-bottom g-0"></div>

      <template v-if="jenis_kegiatan === 'Berusaha'">
        <div class="row mb-3 mt-3">
          <div :class="['col-md-6', { 'pe-none': is_selesai }]">
            <div class="row gx-3">
              <div class="col-12">
                <label class="fw-bold">
                  b. perizinan berusaha
                  <span class="text-danger">*</span></label
                >
                <div class="w-50 pe-2">
                  <v-select
                    v-model="form.perizinan_berusaha"
                    id="b_perizinan_berusaha"
                    :reduce="(data) => data.value"
                    label="text"
                    :options="optionPerizinanBerusaha"
                    name="Perizinan Berusaha"
                    v-validate="'required'"
                  />
                </div>
                <span class="text-danger" v-if="errors.has('Perizinan Berusaha')">
                  {{ errors.first('Perizinan Berusaha') }}
                </span>
              </div>
            </div>
          </div>
        </div>

        <template v-if="form.perizinan_berusaha === 'Sudah'">
          <div v-for="(data, index) in form.data_perizinan_berusaha" :key="index">
            <div v-if="index !== 0" class="row border-bottom g-0 mb-3"></div>
            <div class="row mb-3">
              <div :class="['col-md-7', { 'pe-none': is_selesai }]">
                <div class="row gx-3">
                  <div class="fw-bold">Perizinan Berusaha {{ index + 1 }}</div>
                  <div class="row">
                    <div></div>
                    <div class="col-6 mt-3 g-3">
                      <label>Nomor Perizinan Berusaha {{ index + 1 }} <span class="text-danger">*</span></label>
                      <b-form-input
                        v-model="data.nomor_perizinan"
                        :id="`b_nomor_perizinan_${index + 1}`"
                        v-validate="'required'"
                        :name="`Nomor Perizinan Berusaha ${index + 1}`"
                      ></b-form-input>
                      <span class="text-danger" v-if="errors.has(`Nomor Perizinan Berusaha ${index + 1}`)">
                        {{ errors.first(`Nomor Perizinan Berusaha ${index + 1}`) }}
                      </span>
                    </div>
                    <div class="col-6 mt-3 g-3">
                      <label
                        >Tanggal Terbit Perizinan Berusaha {{ index + 1 }} <span class="text-danger">*</span></label
                      >
                      <DatePicker
                        :id="`b_tgl_terbit_${index + 1}`"
                        lang="en"
                        :placeholder="b_tgl_terbit[index]"
                        input-class="form-control"
                        @change="
                          (e) => {
                            changeDatePerizinanBerusaha(e, index)
                          }
                        "
                        class="w-100"
                      >
                        <i class="fa fa-calendar-o" slot="calendar-icon" />
                      </DatePicker>
                      <span class="text-danger" v-if="errors.has(`Tanggal Terbit Perizinan Berusaha ${index + 1}`)">
                        {{ errors.first(`Tanggal Terbit Perizinan Berusaha ${index + 1}`) }}
                      </span>
                    </div>
                    <div class="col-6 mt-3 g-3">
                      <label
                        >Instansi Penerbit Perizinan Berusaha {{ index + 1 }} <span class="text-danger">*</span></label
                      >
                      <b-form-input
                        v-model="data.instansi_penerbit"
                        :id="`b_instansi_penerbit_${index + 1}`"
                        v-validate="'required'"
                        :name="`Instansi Penerbit Perizinan Berusaha ${index + 1}`"
                      ></b-form-input>
                      <span class="text-danger" v-if="errors.has(`Instansi Penerbit Perizinan Berusaha ${index + 1}`)">
                        {{ errors.first(`Instansi Penerbit Perizinan Berusaha ${index + 1}`) }}
                      </span>
                    </div>
                    <div class="col-6 mt-3 g-3">
                      <label>Masa Berlaku Perizinan Berusaha {{ index + 1 }} <span class="text-danger">*</span></label>
                      <div class="input-units">
                        <b-form-input
                          v-model="data.masa_berlaku"
                          :id="`b_masa_berlaku_${index + 1}`"
                          v-mask="integerMask(data.masa_berlaku)"
                          v-validate="'required'"
                          :name="`Masa Berlaku Perizinan Berusaha ${index + 1}`"
                        ></b-form-input>
                        <div class="text-units">
                          <span>{{ data.masa_berlaku }}</span>
                          <span> tahun</span>
                        </div>
                      </div>
                      <span class="text-danger" v-if="errors.has(`Masa Berlaku Perizinan Berusaha ${index + 1}`)">
                        {{ errors.first(`Masa Berlaku Perizinan Berusaha ${index + 1}`) }}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-5 mt-3">
                <label> Upload dokumentasi/bukti dukung </label>
                <div class="row">
                  <div>
                    <small>Format file: PDF, Ukuran maksimal: 5MB</small>
                  </div>
                  <div class="col-8">
                    <b-form-file
                      v-model="data.dokumentasi"
                      :id="`b_dokumentasi_${index + 1}`"
                      plain
                      class="form-control"
                      :name="`b. Dokumentasi ${index + 1}`"
                      accept=".pdf"
                      @change="checkFileSize($event, `dokumentasi-b${index}`)"
                      :disabled="is_selesai"
                    ></b-form-file>
                  </div>
                  <div v-if="b_id_file_dokumentasi[index]" class="col-4 d-flex">
                    <a
                      :class="{
                        'btn btn-success': true,
                        disabled: b_id_file_dokumentasi[index] === null,
                      }"
                      @click="unduhFile(b_id_file_dokumentasi[index])"
                    >
                      <i class="fa fa-download" />
                      Unduh
                    </a>
                  </div>
                </div>
                <span class="text-danger" v-if="errors.has(`Dokumentasi ${index + 1}`)">
                  {{ errors.first(`Dokumentasi ${index + 1}`) }}
                </span>
                <span class="text-danger" v-if="errors.has(`dokumentasi-b${index}`, 'custom')">
                  {{ errors.first(`dokumentasi-b${index}`, 'custom') }}
                </span>
                <b-button
                  v-if="form.data_perizinan_berusaha.length > 1 && !is_selesai"
                  @click="removePerizinanBerusaha(index)"
                  variant="danger"
                  class="mt-3"
                >
                  <i class="fa fa-trash" />
                  Hapus Perizinan Berusaha {{ index + 1 }}
                </b-button>
              </div>
            </div>
          </div>
        </template>

        <div v-if="!is_selesai" class="row mb-1 pb-3 border-bottom g-0">
          <div v-if="form.perizinan_berusaha === 'Sudah'" class="col-12">
            <b-button @click="addPerizinanBerusaha" variant="secondary" class="me-1">
              <i class="fa fa-plus" />
              Tambah Perizinan Berusaha
            </b-button>
          </div>
        </div>
      </template>

      <template v-if="jenis_kegiatan === 'Non Berusaha'">
        <div class="row mb-3 mt-3">
          <div :class="['col-md-6', { 'pe-none': is_selesai }]">
            <div class="row gx-3">
              <div class="col-12">
                <label class="fw-bold">
                  b. perizinan non berusaha
                  <span class="text-danger">*</span></label
                >
                <div class="w-50 pe-2">
                  <v-select
                    v-model="form.perizinan_nonberusaha"
                    id="b_perizinan_berusaha"
                    :reduce="(data) => data.value"
                    label="text"
                    :options="optionPerizinanNonberusaha"
                    name="Perizinan Non Berusaha"
                    v-validate="'required'"
                  />
                </div>
                <span class="text-danger" v-if="errors.has('Perizinan Non Berusaha')">
                  {{ errors.first('Perizinan Non Berusaha') }}
                </span>
              </div>
            </div>
          </div>
        </div>

        <template v-if="form.perizinan_nonberusaha === 'Sudah'">
          <div v-for="(data, index) in form.data_perizinan_nonberusaha" :key="index">
            <div v-if="index !== 0" class="row border-bottom g-0 mb-3"></div>
            <div class="row mb-3">
              <div :class="['col-md-7', { 'pe-none': is_selesai }]">
                <div class="row gx-3">
                  <div class="fw-bold">Perizinan Non Berusaha {{ index + 1 }}</div>
                  <div class="row">
                    <div></div>
                    <div class="col-6 mt-3 g-3">
                      <label>Nomor Perizinan Non Berusaha {{ index + 1 }} <span class="text-danger">*</span></label>
                      <b-form-input
                        v-model="data.nomor_perizinan"
                        :id="`b_nomor_perizinan_${index + 1}`"
                        v-validate="'required'"
                        :name="`Nomor Perizinan Non Berusaha ${index + 1}`"
                      ></b-form-input>
                      <span class="text-danger" v-if="errors.has(`Nomor Perizinan Non Berusaha ${index + 1}`)">
                        {{ errors.first(`Nomor Perizinan Non Berusaha ${index + 1}`) }}
                      </span>
                    </div>
                    <div class="col-6 mt-3 g-3">
                      <label
                        >Tanggal Terbit Perizinan Non Berusaha {{ index + 1 }} <span class="text-danger">*</span></label
                      >
                      <DatePicker
                        :id="`b_tgl_terbit_${index + 1}`"
                        lang="en"
                        :placeholder="c_tgl_terbit[index]"
                        input-class="form-control"
                        @change="
                          (e) => {
                            changeDatePerizinanNonBerusaha(e, index)
                          }
                        "
                        class="w-100"
                      >
                        <i class="fa fa-calendar-o" slot="calendar-icon" />
                      </DatePicker>
                      <span class="text-danger" v-if="errors.has(`Tanggal Terbit Perizinan Non Berusaha ${index + 1}`)">
                        {{ errors.first(`Tanggal Terbit Perizinan Non Berusaha ${index + 1}`) }}
                      </span>
                    </div>
                    <div class="col-6 mt-3 g-3">
                      <label
                        >Instansi Penerbit Perizinan Non Berusaha
                        {{ index + 1 }}
                        <span class="text-danger">*</span></label
                      >
                      <b-form-input
                        v-model="data.instansi_penerbit"
                        :id="`b_instansi_penerbit_${index + 1}`"
                        v-validate="'required'"
                        :name="`Instansi Penerbit Perizinan Non Berusaha ${index + 1}`"
                      ></b-form-input>
                      <span
                        class="text-danger"
                        v-if="errors.has(`Instansi Penerbit Perizinan Non Berusaha ${index + 1}`)"
                      >
                        {{ errors.first(`Instansi Penerbit Perizinan Non Berusaha ${index + 1}`) }}
                      </span>
                    </div>
                    <div class="col-6 mt-3 g-3">
                      <label
                        >Masa Berlaku Perizinan Non Berusaha {{ index + 1 }} <span class="text-danger">*</span></label
                      >
                      <div class="input-units">
                        <b-form-input
                          v-model="data.masa_berlaku"
                          :id="`b_masa_berlaku_${index + 1}`"
                          v-mask="integerMask(data.masa_berlaku)"
                          v-validate="'required'"
                          :name="`Masa Berlaku Perizinan Non Berusaha ${index + 1}`"
                        ></b-form-input>
                        <div class="text-units">
                          <span>{{ data.masa_berlaku }}</span>
                          <span> tahun</span>
                        </div>
                      </div>
                      <span class="text-danger" v-if="errors.has(`Masa Berlaku Perizinan Non Berusaha ${index + 1}`)">
                        {{ errors.first(`Masa Berlaku Perizinan Non Berusaha ${index + 1}`) }}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-5 mt-3">
                <label> Upload dokumentasi/bukti dukung </label>
                <div class="row">
                  <div>
                    <small>Format file: PDF, Ukuran maksimal: 5MB</small>
                  </div>
                  <div class="col-8">
                    <b-form-file
                      v-model="data.dokumentasi"
                      :id="`b_dokumentasi_${index + 1}`"
                      plain
                      class="form-control"
                      :name="`b. Dokumentasi ${index + 1}`"
                      accept=".pdf"
                      @change="checkFileSize($event, `dokumentasi-b${index}`)"
                      :disabled="is_selesai"
                    ></b-form-file>
                  </div>
                  <div v-if="c_id_file_dokumentasi[index]" class="col-4 d-flex">
                    <a
                      :class="{
                        'btn btn-success': true,
                        disabled: c_id_file_dokumentasi[index] === null,
                      }"
                      @click="unduhFile(c_id_file_dokumentasi[index])"
                    >
                      <i class="fa fa-download" />
                      Unduh
                    </a>
                  </div>
                </div>
                <span class="text-danger" v-if="errors.has(`Dokumentasi ${index + 1}`)">
                  {{ errors.first(`Dokumentasi ${index + 1}`) }}
                </span>
                <span class="text-danger" v-if="errors.has(`dokumentasi-b${index}`, 'custom')">
                  {{ errors.first(`dokumentasi-b${index}`, 'custom') }}
                </span>
                <b-button
                  v-if="form.data_perizinan_nonberusaha.length > 1 && !is_selesai"
                  @click="removePerizinanNonBerusaha(index)"
                  variant="danger"
                  class="mt-3"
                >
                  <i class="fa fa-trash" />
                  Hapus Perizinan Non Berusaha {{ index + 1 }}
                </b-button>
              </div>
            </div>
          </div>
        </template>

        <div v-if="!is_selesai" class="row mb-1 pb-3 border-bottom g-0">
          <div v-if="form.perizinan_nonberusaha === 'Sudah'" class="col-12">
            <b-button @click="addPerizinanNonBerusaha" variant="secondary" class="me-1">
              <i class="fa fa-plus" />
              Tambah Perizinan Non Berusaha
            </b-button>
          </div>
        </div>
      </template>

      <div :class="[{ 'pe-none': is_selesai }]">
        <label>Keterangan/Catatan lain</label>
        <ckeditor id="keterangan_kemajuan_perizinan" :editor="wygEditor" v-model="form.keterangan"></ckeditor>
      </div>

      <div class="mt-5 fw-bold">Note: tanda (<span class="text-danger">*</span>) wajib diisi</div>
    </b-form>

    <b-modal id="modal-panduan" title="Panduan Mengisi Form Kemajuan Perizinan" size="md" body-bg-variant="white">
      <template>
        <div>
          <ul class="mb-0">
            <li>
              Lampirakan Dokumen Perizinan Lingkungan (Apabila belum terbit mohon lampirkan kronologis proses pengajuan
              dan kendala berupa surat keterangan dari intansi terkait atau proses dalam OSS)
            </li>
            <li>
              Lampirkan Dokumen Perizinan Berusaha sesuai dengan Detail Kegiatan Izin KKPRL Terbit atau Kegiatan Utama
              (Apabila belum terbit mohon lampirkan kronologis proses pengajuan dan kendala berupa surat keterangan dari
              intansi terkait atau proses dalam OSS)
            </li>
          </ul>
        </div>
      </template>
      <template #modal-footer>
        <div class="w-100">
          <b-button variant="primary" size="sm" class="float-right" @click="$bvModal.hide('modal-panduan')">
            Tutup
          </b-button>
        </div>
      </template>
    </b-modal>
  </div>
</template>

<script>
import vSelect from 'vue-select'
import ClassicEditor from '@ckeditor/ckeditor5-build-classic'
import DatePicker from 'vue2-datepicker'
import { formatDate } from '../../../helper/helpernew'
import Vue from 'vue'
import { decimalMask, integerMask } from '../../../helper/validationHelper'
import api from '@/services/api'
import { isReadonlyStatus } from './statusRencanaAksi'

import Swal from 'sweetalert2'

export default {
  components: {
    vSelect,
    DatePicker,
  },
  data() {
    return {
      form: {
        persetujuan_lingkungan: 'Sudah',
        a_dokumentasi: null,
        a_nomor_perizinan: '',
        a_tgl_terbit: null,
        a_instansi_penerbit: '',
        a_masa_berlaku: '0',
        perizinan_berusaha: 'Sudah',
        data_perizinan_berusaha: [
          {
            id: null,
            dokumentasi: null,
            nomor_perizinan: '',
            tgl_terbit: null,
            instansi_penerbit: '',
            masa_berlaku: '0',
          },
        ],
        perizinan_nonberusaha: 'Sudah',
        data_perizinan_nonberusaha: [
          {
            id: null,
            dokumentasi: null,
            nomor_perizinan: '',
            tgl_terbit: null,
            instansi_penerbit: '',
            masa_berlaku: '0',
          },
        ],
        keterangan: '',
      },
      dataPerizinan: null,
      id_persiapan_penilaian: null,
      file_perizinan_kkprl: null,
      id_file_perizinan_kkprl: null,
      a_tgl_terbit: 'dd/mm/yyyy',
      b_tgl_terbit: ['dd/mm/yyyy'],
      c_tgl_terbit: ['dd/mm/yyyy'],
      a_id_file_dokumentasi: null,
      b_id_file_dokumentasi: [],
      c_id_file_dokumentasi: [],
      optionPersetujuanLingkungan: [
        { value: 'Sudah', text: 'Sudah' },
        { value: 'Belum Terbit', text: 'Belum Terbit' },
      ],
      optionPerizinanBerusaha: [
        { value: 'Sudah', text: 'Sudah' },
        { value: 'Belum Terbit', text: 'Belum Terbit' },
      ],
      optionPerizinanNonberusaha: [
        { value: 'Sudah', text: 'Sudah' },
        { value: 'Belum Terbit', text: 'Belum Terbit' },
      ],
      wygEditor: ClassicEditor,
      is_selesai: false,
      jenis_kegiatan: null,
    }
  },
  inject: ['setIsSelesai'],
  mounted() {
    this.loadData()
  },
  methods: {
    decimalMask,
    integerMask,
    formatDate,

    changeDatePerizinanBerusaha(val, index) {
      this.errors.remove(`Tanggal Terbit Perizinan Berusaha ${index + 1}`)
      Vue.set(this.b_tgl_terbit, index, val.toLocaleDateString('en-GB'))
      this.form.data_perizinan_berusaha[index].tgl_terbit = formatDate(val, 'YYYY-MM-DD')
    },

    addPerizinanBerusaha() {
      this.form.data_perizinan_berusaha.push({
        id: null,
        dokumentasi: null,
        nomor_perizinan: '',
        tgl_terbit: null,
        instansi_penerbit: '',
        masa_berlaku: '0',
      })
      this.b_tgl_terbit.push('dd/mm/yyyy')
      this.b_id_file_dokumentasi.push(null)
    },

    async removePerizinanBerusaha(i) {
      const idPerizinan = this.form.data_perizinan_berusaha[i].id
      if (idPerizinan !== null) {
        await api.delete(`api/persiapan_penilaian_perizinan_berusaha/${this.form.data_perizinan_berusaha[i].id}`)
      }
      this.form.data_perizinan_berusaha.splice(i, 1)
      this.b_tgl_terbit.splice(i, 1)
      this.b_id_file_dokumentasi.splice(i, 1)
    },

    changeDatePerizinanNonBerusaha(val, index) {
      this.errors.remove(`Tanggal Terbit Perizinan Non Berusaha ${index + 1}`)
      Vue.set(this.c_tgl_terbit, index, val.toLocaleDateString('en-GB'))
      this.form.data_perizinan_nonberusaha[index].tgl_terbit = formatDate(val, 'YYYY-MM-DD')
    },

    addPerizinanNonBerusaha() {
      this.form.data_perizinan_nonberusaha.push({
        id: null,
        dokumentasi: null,
        nomor_perizinan: '',
        tgl_terbit: null,
        instansi_penerbit: '',
        masa_berlaku: '0',
      })
      this.c_tgl_terbit.push('dd/mm/yyyy')
      this.c_id_file_dokumentasi.push(null)
    },

    async removePerizinanNonBerusaha(i) {
      const idPerizinan = this.form.data_perizinan_nonberusaha[i].id
      if (idPerizinan !== null) {
        await api.delete(`api/persiapan_penilaian_perizinan_nonberusaha/${this.form.data_perizinan_nonberusaha[i].id}`)
      }
      this.form.data_perizinan_nonberusaha.splice(i, 1)
      this.c_tgl_terbit.splice(i, 1)
      this.c_id_file_dokumentasi.splice(i, 1)
    },

    async resolveIdPersiapanPenilaian() {
      const existing = this.$route.query.id_persiapan_penilaian
      if (existing) return existing

      const id_rencana_aksi = this.$route.query.id_rencana_aksi
      if (!id_rencana_aksi) return null

      const res = await api.get(`api/persiapan_penilaian?filter=id_rencana_aksi,=,${id_rencana_aksi}`)
      const data = res.data?.data?.[0]
      if (!data?.id) return null

      await this.$router
        .replace({ path: this.$route.path, query: { ...this.$route.query, id_persiapan_penilaian: data.id } })
        .catch(() => {})
      return data.id
    },

    async loadData() {
      const id = await this.resolveIdPersiapanPenilaian()
      if (!id) {
        await this.loadLaporanTahunan()
        return
      }
      this.id_persiapan_penilaian = id

      let data = null
      this.$loading(true)
      try {
        const res = await api.get(`api/persiapan_penilaian/${id}`)
        data = res.data?.data
      } catch (error) {
        data = null
      } finally {
        this.$loading(false)
      }

      if (data) {
        this.is_selesai = isReadonlyStatus(data.status)
        this.setIsSelesai(this.is_selesai)
      }

      // nomor_persetujuan_lingkungan falsy => tab kemajuan perizinan belum diisi
      if (data && data.nomor_persetujuan_lingkungan) {
        await this.applyPersiapanPenilaian(data)
      } else {
        await this.loadLaporanTahunan()
      }
    },

    async applyPersiapanPenilaian(data) {
      this.jenis_kegiatan = data.jenis_kegiatan || null
      this.form = {
        ...this.form,
        persetujuan_lingkungan: data.status_persetujuan_lingkungan || 'Sudah',
        keterangan: data.catatan_kemajuan_perizinan || '',
      }
      if (data.jenis_kegiatan === 'Berusaha') {
        this.form.perizinan_berusaha = data.status_perizinan_berusaha || 'Sudah'
      }
      if (data.jenis_kegiatan === 'Non Berusaha') {
        this.form.perizinan_nonberusaha = data.status_perizinan_nonberusaha || 'Sudah'
      }
      if (data.status_persetujuan_lingkungan === 'Sudah') {
        this.form = {
          ...this.form,
          a_dokumentasi: null,
          a_nomor_perizinan: data.nomor_persetujuan_lingkungan || '',
          a_tgl_terbit: data.tanggal_terbit_persetujuan_lingkungan || null,
          a_instansi_penerbit: data.instansi_penerbit_persetujuan_lingkungan || '',
          a_masa_berlaku:
            data.masa_berlaku_persetujuan_lingkungan != null ? String(data.masa_berlaku_persetujuan_lingkungan) : '0',
        }
      }
      this.a_tgl_terbit = this.form.a_tgl_terbit ? formatDate(this.form.a_tgl_terbit, 'DD/MM/YYYY') : 'dd/mm/yyyy'
      this.a_id_file_dokumentasi = data.id_file_persetujuan_lingkungan || null
      if (data.id_file_perizinan_kkprl) {
        this.id_file_perizinan_kkprl = `${data.id_file_perizinan_kkprl}`
      }

      if (this.jenis_kegiatan === 'Berusaha') {
        await this.loadPersiapanPerizinanBerusaha()
      }
      if (this.jenis_kegiatan === 'Non Berusaha') {
        await this.loadPersiapanPerizinanNonBerusaha()
      }
    },

    async loadPersiapanPerizinanBerusaha() {
      const res = await api.get(
        `api/persiapan_penilaian_perizinan_berusaha?filter=id_persiapan_penilaian,=,${this.id_persiapan_penilaian}&sort=createdAt,ASC`,
      )
      const data2 = res.data.data
      if (data2.length === 0) return

      const resData = []
      const res_tgl = []
      const res_url = []
      for (const x of data2) {
        resData.push({
          id: x.id,
          dokumentasi: null,
          nomor_perizinan: x.nomor_perizinan_berusaha,
          tgl_terbit: x.tanggal_terbit_perizinan_berusaha,
          instansi_penerbit: x.instansi_penerbit_perizinan_berusaha,
          masa_berlaku: String(x.masa_berlaku_perizinan_berusaha),
        })
        res_tgl.push(formatDate(x.tanggal_terbit_perizinan_berusaha, 'DD/MM/YYYY'))
        res_url.push(parseInt(x.file_perizinan_berusaha))
      }
      this.form.data_perizinan_berusaha = resData
      this.b_tgl_terbit = res_tgl
      this.b_id_file_dokumentasi = res_url
    },

    async loadPersiapanPerizinanNonBerusaha() {
      const res = await api.get(
        `api/persiapan_penilaian_perizinan_nonberusaha?filter=id_persiapan_penilaian,=,${this.id_persiapan_penilaian}&sort=createdAt,ASC`,
      )
      const data2 = res.data.data
      if (data2.length === 0) return

      const resData = []
      const res_tgl = []
      const res_url = []
      for (const x of data2) {
        resData.push({
          id: x.id,
          dokumentasi: null,
          nomor_perizinan: x.nomor_perizinan_nonberusaha,
          tgl_terbit: x.tanggal_terbit_perizinan_nonberusaha,
          instansi_penerbit: x.instansi_penerbit_perizinan_nonberusaha,
          masa_berlaku: String(x.masa_berlaku_perizinan_nonberusaha),
        })
        res_tgl.push(formatDate(x.tanggal_terbit_perizinan_nonberusaha, 'DD/MM/YYYY'))
        res_url.push(parseInt(x.file_perizinan_nonberusaha))
      }
      this.form.data_perizinan_nonberusaha = resData
      this.c_tgl_terbit = res_tgl
      this.c_id_file_dokumentasi = res_url
    },

    async nextForm() {
      this.resetFormError()
      if (this.is_selesai) return true

      if (!this.id_file_perizinan_kkprl && !this.file_perizinan_kkprl) {
        this.addFormError('Izin KKPRL Terbit')
      }
      if (this.form.persetujuan_lingkungan === 'Sudah' && this.form.a_tgl_terbit === null) {
        this.addFormError('Tanggal Terbit')
      }
      if (this.jenis_kegiatan === 'Berusaha') {
        for (let i = 0; i < this.form.data_perizinan_berusaha.length; i++) {
          if (this.form.perizinan_berusaha === 'Sudah' && this.form.data_perizinan_berusaha[i].tgl_terbit === null) {
            this.addFormError(`Tanggal Terbit Perizinan Berusaha ${i + 1}`)
          }
        }
      }
      if (this.jenis_kegiatan === 'Non Berusaha') {
        for (let i = 0; i < this.form.data_perizinan_nonberusaha.length; i++) {
          if (
            this.form.perizinan_nonberusaha === 'Sudah' &&
            this.form.data_perizinan_nonberusaha[i].tgl_terbit === null
          ) {
            this.addFormError(`Tanggal Terbit Perizinan Non Berusaha ${i + 1}`)
          }
        }
      }

      if (!(await this.$validator.validateAll()) || this.errors.any()) return false

      this.id_persiapan_penilaian = this.id_persiapan_penilaian || (await this.resolveIdPersiapanPenilaian())
      if (!this.id_persiapan_penilaian) {
        Swal.fire('Gagal', 'Lengkapi tab Identitas terlebih dahulu', 'error')
        return false
      }

      this.$loading(true)
      try {
        await this.savePersiapanPenilaian()

        if (this.jenis_kegiatan === 'Berusaha') {
          await this.savePerizinanBerusaha()
        }
        if (this.jenis_kegiatan === 'Non Berusaha') {
          await this.savePerizinanNonBerusaha()
        }

        Swal.fire('Berhasil', 'Kemajuan Perizinan tersimpan', 'success')
        return true
      } catch (error) {
        const message = error.response?.data?.message || 'Terjadi kesalahan saat menyimpan data'
        Swal.fire('Gagal', message, 'error')
        return false
      } finally {
        this.$loading(false)
      }
    },

    async savePersiapanPenilaian() {
      const formData = new FormData()

      if (this.file_perizinan_kkprl) {
        formData.append('file_perizinan_kkprl', this.file_perizinan_kkprl)
      } else if (this.id_file_perizinan_kkprl) {
        formData.append('id_file_perizinan_kkprl', this.id_file_perizinan_kkprl)
      }
      formData.append('status_persetujuan_lingkungan', this.form.persetujuan_lingkungan)
      formData.append('catatan_kemajuan_perizinan', this.form.keterangan)

      if (this.form.persetujuan_lingkungan === 'Sudah') {
        formData.append('nomor_persetujuan_lingkungan', this.form.a_nomor_perizinan)
        formData.append('tanggal_terbit_persetujuan_lingkungan', this.form.a_tgl_terbit)
        formData.append('instansi_penerbit_persetujuan_lingkungan', this.form.a_instansi_penerbit)
        formData.append('masa_berlaku_persetujuan_lingkungan', parseFloat(this.form.a_masa_berlaku))
      }
      if (this.form.a_dokumentasi) {
        formData.append('file_persetujuan_lingkungan', this.form.a_dokumentasi)
      }
      if (this.jenis_kegiatan === 'Berusaha') {
        formData.append('status_perizinan_berusaha', this.form.perizinan_berusaha)
      }
      if (this.jenis_kegiatan === 'Non Berusaha') {
        formData.append('status_perizinan_nonberusaha', this.form.perizinan_nonberusaha)
      }

      await api.post(`api/persiapan_penilaian/${this.id_persiapan_penilaian}`, formData)
    },

    async savePerizinanBerusaha() {
      if (this.form.perizinan_berusaha !== 'Sudah') {
        for (const x of this.form.data_perizinan_berusaha) {
          if (x.id !== null) {
            await api.delete(`api/persiapan_penilaian_perizinan_berusaha/${x.id}`)
          }
        }
        return
      }

      for (const x of this.form.data_perizinan_berusaha) {
        const formData = new FormData()
        formData.append('id_persiapan_penilaian', this.id_persiapan_penilaian)
        formData.append('nomor_perizinan_berusaha', x.nomor_perizinan)
        formData.append('tanggal_terbit_perizinan_berusaha', x.tgl_terbit)
        formData.append('instansi_penerbit_perizinan_berusaha', x.instansi_penerbit)
        formData.append('masa_berlaku_perizinan_berusaha', x.masa_berlaku)
        if (x.dokumentasi !== null) {
          formData.append('file_perizinan_berusaha', x.dokumentasi)
        }

        await api.post(`api/persiapan_penilaian_perizinan_berusaha` + (x.id !== null ? `/${x.id}` : ''), formData)
      }
    },

    async savePerizinanNonBerusaha() {
      if (this.form.perizinan_nonberusaha !== 'Sudah') {
        for (const x of this.form.data_perizinan_nonberusaha) {
          if (x.id !== null) {
            await api.delete(`api/persiapan_penilaian_perizinan_nonberusaha/${x.id}`)
          }
        }
        return
      }

      for (const x of this.form.data_perizinan_nonberusaha) {
        const formData = new FormData()
        formData.append('id_persiapan_penilaian', this.id_persiapan_penilaian)
        formData.append('nomor_perizinan_nonberusaha', x.nomor_perizinan)
        formData.append('tanggal_terbit_perizinan_nonberusaha', x.tgl_terbit)
        formData.append('instansi_penerbit_perizinan_nonberusaha', x.instansi_penerbit)
        formData.append('masa_berlaku_perizinan_nonberusaha', x.masa_berlaku)
        if (x.dokumentasi !== null) {
          formData.append('file_perizinan_nonberusaha', x.dokumentasi)
        }

        await api.post(`api/persiapan_penilaian_perizinan_nonberusaha` + (x.id !== null ? `/${x.id}` : ''), formData)
      }
    },

    addFormError(fieldName) {
      this.errors.add({
        field: fieldName,
        msg: `${fieldName} wajib diisi`,
      })
    },

    resetFormError() {
      this.errors.clear()
    },

    async loadLaporanTahunan() {
      if (!this.$route.query.id_laporan) {
        return
      }

      this.$loading(true)
      try {
        const req = await api.get(`api/laporan_tahunan/${this.$route.query.id_laporan}`)
        const data = req.data.data

        this.dataPerizinan = {
          jenis_kegiatan: data.jenis_kegiatan,
          nomor_kkprl: data.nomor_kkprl,
        }

        await this.loadPerizinan()

        // this.is_selesai =
        //   data.status_laporan !== null &&
        //   data.status_laporan !== 'Draft' &&
        //   data.status_laporan !== 'Komentar/Informasi terhadap Penyampaian Laporan Tahunan'

        this.form = {
          ...this.form,
          persetujuan_lingkungan: data.status_persetujuan_lingkungan || 'Sudah',
          perizinan_berusaha: data.status_perizinan_berusaha || 'Sudah',
          perizinan_nonberusaha: data.status_perizinan_nonberusaha || 'Sudah',
          keterangan: data.catatan_kemajuan_perizinan || '',
        }
        if (data.status_persetujuan_lingkungan === 'Sudah') {
          this.form = {
            ...this.form,
            a_dokumentasi: null,
            a_nomor_perizinan: data.nomor_persetujuan_lingkungan || '',
            a_tgl_terbit: data.tanggal_terbit_persetujuan_lingkungan || null,
            a_instansi_penerbit: data.instansi_penerbit_persetujuan_lingkungan || '',
            a_masa_berlaku: String(data.masa_berlaku_persetujuan_lingkungan) || '0',
          }
        }

        this.a_tgl_terbit = this.form.a_tgl_terbit ? formatDate(this.form.a_tgl_terbit, 'DD/MM/YYYY') : 'dd/mm/yyyy'
        this.a_id_file_dokumentasi = data.id_file_persetujuan_lingkungan
        this.jenis_kegiatan = data.jenis_kegiatan
        if (data.id_file_perizinan_kkprl) {
          this.id_file_perizinan_kkprl = `${data.id_file_perizinan_kkprl}`
        }

        if (this.jenis_kegiatan === 'Berusaha') {
          const req = await api.get(
            `api/laporan_perizinan_berusaha?filter=id_laporan_tahunan,=,${data.id}&sort=createdAt,ASC`,
          )
          const data2 = req.data.data
          if (data2.length === 0) return
          const res = []
          const res_tgl = []
          const res_url = []
          for (const x of data2) {
            res.push({
              id: null, // data dari laporan, dibuat ulang saat disimpan ke persiapan
              dokumentasi: null,
              nomor_perizinan: x.nomor_perizinan_berusaha,
              tgl_terbit: x.tanggal_terbit_perizinan_berusaha,
              instansi_penerbit: x.instansi_penerbit_perizinan_berusaha,
              masa_berlaku: String(x.masa_berlaku_perizinan_berusaha),
            })
            res_tgl.push(formatDate(x.tanggal_terbit_perizinan_berusaha, 'DD/MM/YYYY'))
            res_url.push(parseInt(x.id_file_perizinan_berusaha))
          }
          this.form.data_perizinan_berusaha = res
          this.b_tgl_terbit = res_tgl
          this.b_id_file_dokumentasi = res_url
        }
        if (this.jenis_kegiatan === 'Non Berusaha') {
          const req = await api.get(
            `api/laporan_perizinan_nonberusaha?filter=id_laporan_tahunan,=,${data.id}&sort=createdAt,ASC`,
          )
          const data2 = req.data.data
          if (data2.length === 0) return
          const res = []
          const res_tgl = []
          const res_url = []
          for (const x of data2) {
            res.push({
              id: null, // data dari laporan, dibuat ulang saat disimpan ke persiapan
              dokumentasi: null,
              nomor_perizinan: x.nomor_perizinan_nonberusaha,
              tgl_terbit: x.tanggal_terbit_perizinan_nonberusaha,
              instansi_penerbit: x.instansi_penerbit_perizinan_nonberusaha,
              masa_berlaku: String(x.masa_berlaku_perizinan_nonberusaha),
            })
            res_tgl.push(formatDate(x.tanggal_terbit_perizinan_nonberusaha, 'DD/MM/YYYY'))
            res_url.push(parseInt(x.id_file_perizinan_nonberusaha))
          }
          this.form.data_perizinan_nonberusaha = res
          this.c_tgl_terbit = res_tgl
          this.c_id_file_dokumentasi = res_url
        }
      } finally {
        this.$loading(false)
      }
    },

    async loadPerizinan() {
      const nomor_kkprl = this.dataPerizinan.nomor_kkprl
      let resData = {}
      if (this.dataPerizinan.jenis_kegiatan === 'Berusaha') {
        const res = await api.get(`api/ref/getPermohonan/Berusaha?filter=nomor_oss,=,${nomor_kkprl}`)
        resData = res.data.data[0]
        if (!resData) return
        this.id_file_perizinan_kkprl = resData.file_final_oss
      } else {
        const res = await api.get(`api/ref/getPermohonan/Nonberusaha?filter=nomor_kkp,=,${nomor_kkprl}`)
        resData = res.data.data[0]
        if (!resData) return
        this.id_file_perizinan_kkprl = resData.file_izin_ttd
      }
    },

    checkFileSize(e, field) {
      const file = e.target.files[0]
      const maxSize = 5 * 1024 * 1024

      if (file && file.size > maxSize) {
        this.errors.add({
          field: field,
          msg: 'Ukuran file maksimal 5MB',
          scope: 'custom',
        })
        e.target.value = null
      } else {
        this.errors.remove(field, 'custom')
      }
    },

    async unduhFile(id) {
      const res = await api.get(`api/files/download/${id}`, { responseType: 'blob' })
      const file = new Blob([res.data], { type: res.data.type })
      const fileURL = URL.createObjectURL(file)
      window.open(fileURL, '_blank')
    },
  },
}
</script>
